module.exports = __webpack_public_path__ + "img/pic.87d5f85d.png";